export default __webpack_public_path__ + "static/media/icon.e7b5c147.png";